import {
  types,
  IGetGroupsAction,
  IGetGroupsSuccessAction,
  IFailureAction,
} from '../types/groups'
import { IGroup } from '../types/group'

export const getGroups = (): IGetGroupsAction => ({
  type: types.GET_GROUPS__STARTED,
})

export const getGroupsSuccess = (list: IGroup[]): IGetGroupsSuccessAction => ({
  type: types.GET_GROUPS__SUCCESS,
  list,
})

export const getGroupsFailure = (message: string): IFailureAction => ({
  type: types.GET_GROUPS__FAILURE,
  message,
})
